'use client';

import { createContext, useContext, useState, useMemo } from 'react';

export const FORM_MODE_NEW = 'new';
export const FORM_MODE_DETAILS = 'details';
export const FORM_MODE_EDIT = 'edit';

export const isNewMode = (mode) => mode === FORM_MODE_NEW;
export const isDetailsMode = (mode) => mode === FORM_MODE_DETAILS;
export const isEditMode = (mode) => mode === FORM_MODE_EDIT;

export const isEditableMode = (mode) => isNewMode(mode) || isEditMode(mode);

// 1. Create the Context with a default value and structure
export const FormModeContext = createContext(
   ({
      mode: 'new', // Default initial mode
      setMode: () => { console.error("setMode function not provided by FormModeProvider"); }
   })
);

// 2. Create the Provider Component
export const FormModeProvider = ({ initialMode = 'new', children }) => {
   const [mode, setMode] = useState(initialMode);
   
   // Memoize the context value to prevent unnecessary re-renders in consumers
   const contextValue = useMemo(() => ({ mode, setMode }), [mode]);
   
   return (
      <FormModeContext.Provider value={contextValue}>
         {children}
      </FormModeContext.Provider>
   );
};

// 3. Custom Hook for easy consumption
export const useFormMode = () => {
   const context = useContext(FormModeContext);
   if (context === undefined) {
      throw new Error('useFormMode must be used within a FormModeProvider');
   }
   return context;
};